import { Instance } from 'mobx-state-tree';
import { RouteDeletingFailedDtoModelBase } from './RouteDeletingFailedDtoModel.base';

/* The TypeScript type of an instance of RouteDeletingFailedDtoModel */
export interface RouteDeletingFailedDtoModelType extends Instance<typeof RouteDeletingFailedDtoModel.Type> {}

/* A graphql query fragment builders for RouteDeletingFailedDtoModel */
export { selectFromRouteDeletingFailedDto, routeDeletingFailedDtoModelPrimitives, RouteDeletingFailedDtoModelSelector } from './RouteDeletingFailedDtoModel.base';

/**
 * RouteDeletingFailedDtoModel
 *
 * Route deleting failed event
 */
export const RouteDeletingFailedDtoModel = RouteDeletingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
